import moment from "moment";

// 線上支付（付款成功後即視為已結帳）
const ONLINE_PAYMENT_TYPES = ['linePay', 'jkoPay'];

export default class OrderCheckout {
    constructor(data) {
        const isOnlinePayment = ONLINE_PAYMENT_TYPES.includes(data.payment.paymentType);
        // 櫃檯結帳 / 店家自訂支付於門市結帳，checkoutTime 填 null
        if (isOnlinePayment) {
            this.checkoutTime = moment().utc().format()
        } else {
            this.checkoutTime = null
        }
        if (isOnlinePayment) {
            this.payment = data.payment.paymentPrice
        } else {
            this.payment = 0
        }
        this.stagedTime = moment().utc().format(),
            this.store = data.store_code || null,
            // randomNumber 需改為使用random 亂數產生 0000 ~ 9999
            // 並以4碼數字字串表示
            this.randomNumber = (Math.floor(Math.random() * 9999)).toString().padStart(4, '0'),
            this.sellerTaxID = null,
            // 保留 invoiceNumber 以維持向後相容性（但不使用）
            this.invoiceNumber = null,
            this.isTestSiteInvoice = null,

            // 根據 invoiceTypeIndex 條件傳遞發票資料
            // invoiceTypeIndex: 0=手機載具, 1=統一編號, 2=愛心碼
            this.buyerTaxID = null,
            this.eInvoiceBarCode = null,
            this.npoCode = null,
            this.note = data.payment.comment || null,
            this.paymentType = data.payment.paymentType,
            this.paymentExtra = null,
            this.eventDiscount = null,
            this.onSiteDiscount = null,
            this.extraFee = null,
            this.taxFreeOnSiteDiscount = null,
            this.shippingFee = data.payment.shippingFee || 0,
            this.discountRate = null,
            this.hiddenCost = null,
            this.status = null,
            this.statusNote = null,
            this.abandonRequester = null,
            this.checkoutStaff = null,
            this.refunder = null,
            this.refundStaff = null,
            this.storeMemberUUID = data.store_member_uuid || null,
            this.pointIncrease = null,
            this.pointDecrease = null,
            this.vipLevel = data.vipLevel || 1,
            //Add By Bryant 2025/08/22 Begin
            this.userMobileTail = data.payment.userMobileTail || null,
            //Add By Bryant 2025/08/22 End
            this.storeServiceFeeSetting = new ServiceFeeSetting(data.storeServiceFeeSetting)

        // 條件傳遞發票資料：根據 invoiceTypeIndex 只設定對應的發票欄位
        // invoiceTypeIndex: 0=紙本發票, 1=手機載具, 2=統一編號, 3=愛心碼
        const invoiceTypeIndex = data.payment?.invoiceTypeIndex ?? 0;

        if (invoiceTypeIndex === 0) {
            // 紙本發票：不設定任何發票欄位
            this.eInvoiceBarCode = null;
            this.buyerTaxID = null;
            this.npoCode = null;
        } else if (invoiceTypeIndex === 1) {
            // 手機載具：只設定 eInvoiceBarCode
            this.eInvoiceBarCode = data.payment?.invoiceCarrier || null;
            this.buyerTaxID = null;
            this.npoCode = null;
        } else if (invoiceTypeIndex === 2) {
            // 統一編號：只設定 buyerTaxID
            this.eInvoiceBarCode = null;
            this.buyerTaxID = data.payment?.invoiceVatNumber || null;
            this.npoCode = null;
        } else if (invoiceTypeIndex === 3) {
            // 愛心碼：只設定 npoCode
            this.eInvoiceBarCode = null;
            this.buyerTaxID = null;
            this.npoCode = data.payment?.invoiceNpoBan || null;
        }

        // 紅利積分折抵（1 點 = 1 元）：改為訂單成立後扣點，此處僅記錄供 POS 辨識
        // prePointDecrease：正整數（扣除點數）；prePointDiscount：負數（折抵金額）
        const pointUsed = Math.max(0, Math.floor(Number(data.payment.pointQuantity) || 0));
        const usePointDiscount = pointUsed > 0;
        this.prePointDecrease = usePointDiscount ? pointUsed : null;
        this.prePointDiscount = usePointDiscount ? -pointUsed : null;
    }
}

class ServiceFeeSetting {
    constructor(data) {
        this.serviceFeeCalc = data.serviceFeeMode,
            this.fromOriginalRate = data.serviceFeeRate,
            this.afterDiscountRate = data.serviceFeeRate,
            this.serviceFeeName = data.serviceFeeName ?? null
    }
}
